import { DialogContent, Grid } from '@mui/material';
import { FC } from 'react';
import { WsDialog, Label, WsButton } from 'wisestep-base';
export interface ConfirmationDialogProps {
  openDialog: boolean;
  closeDialog(): void;
  handler: (type: 'reset' | 'clear') => void;
  variant: 'reset' | 'clear';
}
const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  openDialog,
  closeDialog,
  handler,
  variant,
}) => (
  <WsDialog openDialog={openDialog} size="small">
    <DialogContent>
      <Grid container spacing={1} direction="column">
        <Grid item xs={12}>
          {variant === 'clear' && (
            <Label sx={{ fontWeight: 'bold' }}>
              Are you sure you want to ignore current changes if any?
            </Label>
          )}
          {variant === 'reset' && (
            <Label sx={{ fontWeight: 'bold' }}>
              Are you sure you want to reset to Platform default?
            </Label>
          )}
        </Grid>
        <Grid item width="40%" display="flex" justifyContent="space-between" alignSelf="center">
          <WsButton onClick={() => handler(variant)}>Yes</WsButton>
          <WsButton onClick={() => closeDialog()}>No</WsButton>
        </Grid>
      </Grid>
    </DialogContent>
  </WsDialog>
);

export default ConfirmationDialog;
